import D28dChallengesAdmin from '../d28d/D28dChallengesAdmin';

/** Premiaciones por ciclo propias del gimnasio virtual. */
export default function GymMastersChallenges({ onBack, scopeGymId = null }) {
  return (
    <D28dChallengesAdmin
      gymScoped
      scopeGymId={scopeGymId}
      onBack={onBack}
    />
  );
}
